/**
 * final static variables
 */
// chart types
export const BAR_CHART = 'bar'
export const LINE_CHART = 'line'
export const MONETIZATION_TYPE_BETA = 'beta' // mainly used for downstream logic (e.g. detailstable)

// available metrics
export const NET_REVENUE = 'NET_REVENUE'
export const GROSS_REVENUE = 'GROSS_REVENUE'
export const TOTAL_IMPRESSIONS = 'TOTAL_IMPRESSIONS'
export const INITIAL_IMPRESSIONS = 'INITIAL_IMPRESSIONS'
export const REFRESH_IMPRESSIONS = 'REFRESH_IMPRESSIONS'
export const PAGE_VIEWS = 'MONETIZABLE_PAGE_VIEW'
export const AD_REQUEST = 'AD_REQUEST'
export const BID_RATE = 'BID_RATE'
export const WIN_RATE = 'WIN_RATE'
export const BID_REQUEST = 'BID_REQUEST'
export const BID_RESPONSE = 'BID_RESPONSE'
export const WINNING_BID = 'WINNING_BID'
export const GROSS_REVENUE_WITHOUT_DISCREPANCY = 'GROSS_REVENUE_WITHOUT_DISCREPANCY'
export const AVG_RPM = 'AVG_RPM'
export const AVG_CPM = 'AVG_CPM'
export const CTR = 'CTR'
export const VIEWABILITY = 'VIEWABILITY'
export const INITIAL_VIEWABILITY = 'INITIAL_VIEWABILITY'
export const REFRESH_VIEWABILITY = 'REFRESH_VIEWABILITY'
export const IMPRESSION_PER_PAGEVIEW = 'IMPRESSION_PER_PAGEVIEW'
export const VIDEO_COMPLETION_RATE = 'VIDEO_COMPLETION_RATE'
export const DATA_CSV_DOWNLOAD_VIEW = 'CSV_DOWNLOAD_VIEW'
export const DATA_DASHBOARD_VIEW = 'DATA_DASHBOARD_VIEW'
export const VIDEO_VIEWED = 'VIDEO_VIEWED'
export const VIDEO_START = 'VIDEO_START'
export const VIDEO_Q1 = 'VIDEO_Q1'
export const VIDEO_Q2 = 'VIDEO_Q2'
export const VIDEO_Q3 = 'VIDEO_Q3'
export const VIDEO_COMPLETE = 'VIDEO_COMPLETE'
export const VIDEO_CLICK = 'VIDEO_CLICK'


// available dimensions
export const SITE = 'SITE'
export const GEO = 'GEO'
export const DEVICE = 'DEVICE'
export const AD_UNIT = 'AD_UNIT' // also for pageview type
export const PRODUCT_TYPE = 'PRODUCT_TYPE'
export const REVENUE_TYPE = 'REVENUE_TYPE'
export const INTEGRATION = 'INTEGRATION'

// pageview specific
export const PAGEVIEW_TYPE = 'PAGEVIEW_TYPE'
export const CEU_CMT = 'CEU_CMT'
export const VIDEO = 'VIDEO'
export const TOTAL = 'TOTAL'

export const DIMENSION_DROPDOWN_OPTIONS = [
  { name: 'Site', value: SITE },
  { name: 'Country', value: GEO },
  { name: 'Device', value: DEVICE },
  { name: 'Ad Unit', value: AD_UNIT },
  { name: 'Product', value: PRODUCT_TYPE },
  { name: 'Revenue Type', value: REVENUE_TYPE }
]

export const INITIAL_STATE = {
  DAILY: { TOTAL: {} },
  MONTHLY: { TOTAL: {} },
  QUARTERLY: { TOTAL: {} },
  WEEKLY: { TOTAL: {} },
  TOTAL: { TOTAL: { data: 0, changeRate: 0 } },
  csvdata: {},
  status: 'pending',
  csvdatastatus: '',
  csvDownloadLinkParams: {}
}

export const METRIC_UNIT = {
  [NET_REVENUE]: 'dollar',
  [GROSS_REVENUE]: 'dollar',
  [TOTAL_IMPRESSIONS]: 'number',
  [INITIAL_IMPRESSIONS]: 'number',
  [REFRESH_IMPRESSIONS]: 'number',
  [PAGE_VIEWS]: 'number',
  [AVG_RPM]: 'dollar',
  [AVG_CPM]: 'dollar',
  [CTR]: 'percentage',
  [AD_REQUEST]: 'number',
  [BID_RATE]: 'percentage',
  [WIN_RATE]: 'percentage',
  [VIEWABILITY]: 'percentage',
  [INITIAL_VIEWABILITY]: 'percentage',
  [REFRESH_VIEWABILITY]: 'percentage'
}

const initialDropdownState = {
  first: null, second: null
}

export const TOOLTIP_CONTENTS = {
  revenue: <div className={'tip-content'}>
                    <div className={'tip-title'}>
                        <h4>Publisher Revenue</h4>
                    </div>
                    <div className={'tip-desc'}>
                        <p>Shown revenue is your total net ad revenue, for the selected time period.
                            Net revenue is your portion of revenue after the negotiated
                            Insticator portion of the revenue share.</p>
                        <p>Factors that can influence revenue are:</p>
                        <ul>
                            <li>Seasonality</li>
                            <li>CPM</li>
                            <li>Page views</li>
                            <li>Session duration</li>
                            <li>Ad sizes</li>
                            <li>Quantity of ad placements</li>
                            <li>Ad formats (display, video)</li>
                            <li>Ad fill rates</li>
                            <li>Viewability</li>
                        </ul>
                    </div>
                </div>,
  rpmCpm: <div className={'tip-content'}>
                    <div className={'tip-title'}>
                        <h4>Average RPM</h4>
                    </div>
                    <div className={'tip-desc'}>
                        <p>Average RPM is the total net ad revenue per thousand monetizable page
                            views and is calculated by taking the total net revenue, for the selected
                            time period, and dividing it by the total monetizable page views, then
                            multiplying by 1,000.</p>

                        <p>Note: A “Monetizable Page View” is defined as the first insticator element
                            loaded on a page EXCLUDING the header</p>

                        <p>Some publishers will see Avg. CPM metric. That metric is calculated by
                            taking the total net revenue and dividing by total impressions (both
                            initial load impressions and refresh impressions)</p>

                    </div>
                </div>,
  pageview: <div className={'tip-content'}>
                    <div className={'tip-title'}>
                        <h4>Monetizable Page Views</h4>
                    </div>
                    <div className={'tip-desc'}>
                        <p>A “Monetizable Page View” is defined as the first insticator element loaded
                            on a page EXCLUDING the header. The Monetizable Page Views report is a count
                            of those page views for the selected time period. It excludes page views
                            from bots, robots, crawlers or pages without advertisements.</p>
                    </div>
                </div>,
  impression: <div className={'tip-content'}>
                    <div className={'tip-title'}>
                        <h4>Engagement Products Impressions</h4>
                    </div>
                    <div className={'tip-desc'}>
                        <p>Total count of ad impressions for ONLY your engagement products: Commenting & Trivia & Polls.</p>
                    </div>
                </div>,
  viewability: <div className={'tip-content'}>
                    <div className={'tip-title'}>
                        <h4>Avg Ad Viewability</h4>
                    </div>
                    <div className={'tip-desc'}>
                        <p>The Ad Viewability metrics for this report come directly from Google Ad
                                Management (GAM) data. Google, therefore, defines what is viewable. Current
                                definition per Google Support page is:</p>
                        <p>An impression is considered a viewable impression when it has appeared within
                            a user’s browser and had the opportunity to be seen. The Interactive
                            Advertising Bureau (IAB) defines a viewable impression as an ad that meets
                            the following criteria:</p>
                        <ul>
                            <li>For ads, 50% of the ad’s pixels are visible in the browser window for a continuous 1
                                second.</li>
                            <li>For larger ads (those greater than 242,000 pixels), 30% of the ad’s pixels are visible
                                in the browser window.</li>
                        </ul>
                    </div>
                </div>,
  videoRevenue: <div className={'tip-content'}>
                        <div className={'tip-title'}>
                            <h4>Publisher Video Revenue</h4>
                        </div>
                        <div className={'tip-desc'}>
                            <p>Shown revenue is your total net ad revenue, for the selected time period. Net revenue
                                 is your portion of revenue after the negotiated COOL Media portion of the
                                 revenue share.</p>
                            <p>Factors that can influence revenue are:</p>
                            <ul>
                                <li>Seasonality</li>
                                <li>CPM</li>
                                <li>Site traffic</li>
                                <li>Ad size and placement</li>
                                <li>Display vs. video ads</li>
                                <li>Ad fill rates</li>
                                <li>Viewability of the ad</li>
                                <li>Refresh rates</li>
                            </ul>
                        </div>
                    </div>,
  videoRpmCpm: <div className={'tip-content'}>
                        <div className={'tip-title'}>
                            <h4>Average Video RPM</h4>
                        </div>
                        <div className={'tip-desc'}>
                            <p>Average Video RPM is the total net video ad revenue per thousand monetizable
                                page views and is calculated by taking the total net video revenue, for
                                the selected time period, and dividing it by the total monetizable page
                                views, then multiplying by 1,000.</p>
                            <p>Note: A “Monetizable Page View” is defined as the first insticator element
                                loaded on a page EXCLUDING the header</p>
                            <p>Some publishers will see Avg. Video CPM metric. That metric is calculated
                                by taking the total net video revenue and dividing by total video impressions</p>
                        </div>
                    </div>,
  videoImpression: <div className={'tip-content'}>
                            <div className={'tip-title'}>
                                <h4>Video Ad Impressions</h4>
                            </div>
                            <div className={'tip-desc'}>
                                <p>Total count of video ad impressions</p>
                            </div>
                        </div>,
  videoViewability: <div className={'tip-content'}>
                            <div className={'tip-title'}>
                                <h4>Avg Video Viewability</h4>
                            </div>
                            <div className={'tip-desc'}>
                                <p>The Video Viewability metrics for this report come directly from Google Ad
                                    Management (GAM) data. Google, therefore, defines what is viewable. Current
                                    definition per Google Support page is:.</p>
                                <p>The Media Rating Council (MRC) and the Interactive Advertising Bureau (IAB)
                                    defined what viewable means. If 50% of a video ad’s pixels appear on-screen
                                    for at least 2 consecutive seconds, an ad is deemed viewable.</p>
                            </div>
                        </div>,
  cpm: <div className={'tip-content'}>
        <div className={'tip-title'}>
            <h4>Average CPM</h4>
        </div>
        <div className={'tip-desc'}>
            <p>Average CPM is the total net ad revenue per thousand impressions and is calculated by taking the total net revenue, for the selected time period, and dividing it by the total impressions, then multiplying by 1,000.</p>
        </div>
    </div>,
  adRequest: <div className={'tip-content'}>
        <div className={'tip-title'}>
            <h4>Ad Requests and Impressions</h4>
        </div>
        <div className={'tip-desc'}>
            <p>The Total number of Ad Requests received.</p>
            <p>Impressions is the number of the times an ad has rendered on the page.</p>
        </div>
    </div>,
  bidResponse: <div className={'tip-content'}>
        <div className={'tip-title'}>
            <h4>Bid Rate and Win Rate</h4>
        </div>
        <div className={'tip-desc'}>
            <p>Bid rate is defined as the total number of Bid responses received divided by the total number of Bid requests and it is multiplied by 100 to display as a percentage</p>
            <p>Win rate is defined as the total number of Impressions rendered divided by the total number of Bid responses and it is multiplied by 100 to display as a percentage</p>
        </div>
    </div>
}

export const DIMENSION_DROPDOWN_STATE = {
  [NET_REVENUE]: { ...initialDropdownState },
  [GROSS_REVENUE]: { ...initialDropdownState },
  [TOTAL_IMPRESSIONS]: { ...initialDropdownState },
  [INITIAL_IMPRESSIONS]: { ...initialDropdownState },
  [REFRESH_IMPRESSIONS]: { ...initialDropdownState },
  [PAGE_VIEWS]: { ...initialDropdownState },
  [AVG_RPM]: { ...initialDropdownState },
  [AVG_CPM]: { ...initialDropdownState },
  [AD_REQUEST]: { ...initialDropdownState },
  [BID_RATE]: { ...initialDropdownState },
  [WIN_RATE]: { ...initialDropdownState },
  [CTR]: { ...initialDropdownState },
  [VIEWABILITY]: { ...initialDropdownState },
  [INITIAL_VIEWABILITY]: { ...initialDropdownState },
  [REFRESH_VIEWABILITY]: { ...initialDropdownState }
}

export const DISABLED_SECONDARY_DIMENSIONS = ['TOTAL', 'OTHERS', IMPRESSION_PER_PAGEVIEW, VIDEO_COMPLETION_RATE]
